var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1636 7.63574C13.3581 8.29383 13.7174 8.88122 14.1935 9.35018L10.8366 11.3644C10.6421 10.7063 10.2828 10.1189 9.80664 9.64994L13.1636 7.63574Z",
    fill: "#00E7A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80664 15.3502L13.1636 17.3643C13.3581 16.7063 13.7173 16.1189 14.1935 15.6499L10.8366 13.6357C10.6421 14.2938 10.2828 14.8812 9.80664 15.3502Z",
    fill: "#00E7A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8.5C18.1046 8.5 19 7.60457 19 6.5C19 5.39543 18.1046 4.5 17 4.5C15.8954 4.5 15 5.39543 15 6.5C15 7.60457 15.8954 8.5 17 8.5ZM21 6.5C21 8.70914 19.2091 10.5 17 10.5C14.7909 10.5 13 8.70914 13 6.5C13 4.29086 14.7909 2.5 17 2.5C19.2091 2.5 21 4.29086 21 6.5Z",
    fill: "#00E7A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 20.5C18.1046 20.5 19 19.6046 19 18.5C19 17.3954 18.1046 16.5 17 16.5C15.8954 16.5 15 17.3954 15 18.5C15 19.6046 15.8954 20.5 17 20.5ZM21 18.5C21 20.7091 19.2091 22.5 17 22.5C14.7909 22.5 13 20.7091 13 18.5C13 16.2909 14.7909 14.5 17 14.5C19.2091 14.5 21 16.2909 21 18.5Z",
    fill: "#00E7A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14.5C8.10457 14.5 9 13.6046 9 12.5C9 11.3954 8.10457 10.5 7 10.5C5.89543 10.5 5 11.3954 5 12.5C5 13.6046 5.89543 14.5 7 14.5ZM11 12.5C11 14.7091 9.20914 16.5 7 16.5C4.79086 16.5 3 14.7091 3 12.5C3 10.2909 4.79086 8.5 7 8.5C9.20914 8.5 11 10.2909 11 12.5Z",
    fill: "#00E7A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.71e6e84670e826b57c6e581ce96ee432.svg";
export { ForwardRef as ReactComponent };